import { render, staticRenderFns } from "./v-workplace-chip.vue?vue&type=template&id=4478bdde&"
import script from "./v-workplace-chip.vue?vue&type=script&lang=js&"
export * from "./v-workplace-chip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports